export enum UserMessages {
  DOCUMENT_NO_EXPIRATION = 'No hay información de la fecha de vencimiento de la RTM y EPS del conductor.',
  DOCUMENT_EXPIRATED = 'La %s del conductor esta vencida.',
  DOCUMENT_INSUFFICIENT_VALIDITY = 'La %s estará vencida para la fecha de llegada.',
  DOCUMENT_PENDING_APPROVAL = 'La %s se encuentra pendiente de validacion.',
  DOCUMENT_ACTIVE = 'Documentos vigentes.',
  DOCUMENT_INACTIVE = "Documentos insuficientes",
  DOCUMENT_SECURITY_STUDY_IN_PROGRESS = 'El estudio de seguridad para validar la %s se encuentra en proceso.'
}
